import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  FormControlLabel,
  IconButton,
  LinearProgress,
  Paper,
  Rating,
  Switch,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Constants from "../../../data/Constants";
import Skeleton from "react-loading-skeleton";
import {
  deactivateMentee,
  getSingleUser,
} from "../../../services/user.service";
import CourseCard from "../../../components/CourseCard";
import { MdChildCare, MdContentCopy } from "react-icons/md";
import BillingDialog from "components/BillingDialog";
import { TbCircleCheck } from "react-icons/tb";
import { BsCalendarDay, BsFillCalendarFill } from "react-icons/bs";
import { FaRegCalendarAlt } from "react-icons/fa";
import { getRescheduleSessions } from "services/session.service";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useConfirm } from "material-ui-confirm";
function SingleMentee(props) {
  const confirm = useConfirm();
  const [data, setData] = useState();
  const [copy, setCopy] = useState(false);
  const [rs, setRs] = useState([]); // reschedule requests
  const [billingDialog, setBillingDialog] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { setProgress, setToast } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const res = await getSingleUser(id);
        if (res) {
          setData(res);
          console.log(res);
          setProgress(false);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
        setProgress(false);
      }
    }

    async function api2() {
      if (id) {
        try {
          const res = await getRescheduleSessions({ user: id });
          setRs(res);
          console.log(res);
        } catch (error) {
          // error
          console.log(error);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      }
    }

    api();
    api2();
  }, []);

  const handledeactivateUser = () => {
    confirm({
      title: "Delete User",
      description: "Are you sure you want to delete this User Account?",
    })
      .then(async () => {
        try {
          setProgress(true);
          const res = await deactivateMentee(id);
          if (res) {
            setProgress(false);
            setToast({ error: false, message: "Mentee Deleted Successfully" });
          } else {
            // error
            setToast({ error: true, message: Constants.Error.UNKNOWN });
            setProgress(false);
          }
        } catch (error) {
          // error
          console.log(error);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      })
      .catch(() => {});
  };
  return (
    data && (
      <div className="grid">
        <div className="grid grid-cols-3">
          <div className="w-full  flex grid-flow col-span-3 sm:col-span-1 items-center justify-center">
            {<Avatar src={data.picture} sx={{ width: 150, height: 150 }} />}
          </div>
          <div className="sm:col-span-2 col-span-3  py-5 px-6">
            {data.firstname ? (
              <h1 className="text-3xl font-extrabold">
                {data.firstname + " " + data.lastname}
              </h1>
            ) : (
              "No Name"
            )}
            <div className="text-sm text-gray-700">
              <b className="pr-2">ID:</b>
              {data._id}
              <Tooltip title={copy ? "ID Copied!" : "Copy Mentee ID"}>
                <span>
                  <CopyToClipboard
                    text={data._id}
                    onCopy={() => {
                      setCopy(true);
                      setTimeout(() => {
                        setCopy(false);
                      }, 2000);
                    }}
                  >
                    <IconButton
                      size="small"
                      variant="contained"
                      onClick={() => {}}
                    >
                      <MdContentCopy />
                    </IconButton>
                  </CopyToClipboard>
                </span>
              </Tooltip>
            </div>
            <h1 className="text-sm">
              <b>Profession:</b> {data.profession ?? "Not Set"}
            </h1>
            <h1 className="text-sm">
              <b>Address:</b> {data.address ?? "Not Set"}
            </h1>
            <h1 className="text-sm">
              <b>City:</b> {data.city ?? "Not Set"}
            </h1>
            <h1 className="text-sm">
              <b>Email:</b> {data.email ?? "Not Set"}
            </h1>
            <h1 className="text-sm">
              <b>Mobile:</b> {data.mobile ?? "Not Set"}
            </h1>

            <h1 className="text-sm">
              <b>Deleted:</b> {data.deleted.toString()}
            </h1>

            <div>
              {/* <FormControlLabel
                control={
                  <Switch
                    checked={true}
                    // onChange={formik.handleChange}
                  />
                }
                label="Activated"
                name="isCounsellingEnabled"
              /> */}
            </div>

            <div className=" flex gap-2 my-2">
              <Button
                variant="outlined"
                onClick={handledeactivateUser}
                disabled={data.deleted}
              >
                {data.deleted ? "Deleted" : "Delete"}
              </Button>

              <Button
                variant="outlined"
                onClick={() => {
                  setBillingDialog(true);
                }}
              >
                View Billing
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  if (data.cart) {
                    navigate("/dashboard/mentees/cart/" + data.cart);
                  }
                }}
              >
                View Cart
              </Button>

              <Button
                variant="outlined"
                onClick={() => {
                  if (id) {
                    navigate("/dashboard/mentees/orders/" + id);
                  }
                }}
              >
                View Orders
              </Button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 my-3">
          <div className="my-2 ">
            <h1 className="text-xl font-extrabold ">Statistics</h1>
            <div className="my-2 grid grid-cols-3">
              <div className="flex flex-col items-center justify-center">
                <b>Bought Courses</b>
                <div className="font-bold text-4xl">
                  {data.boughtCourses.length}
                </div>
              </div>

              <div className="flex flex-col items-center justify-center">
                <b>Total Students</b>
                <div className="font-bold text-4xl">{data.students.length}</div>
              </div>

              <div className="flex flex-col items-center justify-center">
                <b>Total Sessions</b>
                <div className="font-bold text-4xl">
                  {data.schedule.courses.length +
                    data.schedule.counselling.length}
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2">
            <div>
              <div className="my-2">
                <h1 className="text-xl font-extrabold"> Students</h1>
                <div className="my-2 flex gap-4">
                  {data.students.length != 0 ? (
                    data.students.map((student, index) => {
                      return (
                        <div
                          className=" bg-gray-100 p-5 rounded-sm shadow-lg cursor-pointer justify-center"
                          onClick={() =>
                            navigate("/dashboard/students/" + student._id)
                          }
                        >
                          <div className="justify-center flex mb-2">
                            <Avatar sx={{ width: 50, height: 50 }} />
                          </div>
                          <h1 className="text-md font-extrabold">
                            {student.firstname + " " + student.lastname}
                          </h1>
                          <h1 className="text-sm">Grade: {student.grade}</h1>
                          <h1 className="text-sm">
                            DOB: {moment(student.dob).format("DD-MM-YYYY")}
                          </h1>
                        </div>
                      );
                    })
                  ) : (
                    <div className="py-5 text-gray-600"> No Students </div>
                  )}
                </div>
              </div>

              <div className="my-2">
                <h1 className="text-xl font-extrabold">Mentee Learnings</h1>
                <div className="my-2 flex gap-4 flex-wrap">
                  {data.boughtCourses.length != 0 ? (
                    data.boughtCourses.map((bCourse, index) => {
                      return (
                        <CourseCard
                          course={bCourse.course}
                          className="cursor-pointer"
                          key={index}
                          children={
                            <div className="w-full">
                              <div className="flex gap-2  items-center p-1 text-sm">
                                Progress:{" "}
                                {bCourse.completedTopics +
                                  " of " +
                                  bCourse.totalTopics}
                                {bCourse.completedTopics ==
                                  bCourse.totalTopics && (
                                  <TbCircleCheck size={18} />
                                )}
                              </div>

                              <LinearProgress
                                variant="determinate"
                                value={
                                  (bCourse.completedTopics /
                                    bCourse.totalTopics) *
                                  100
                                }
                              />
                            </div>
                          }
                          hideActionBar
                          onClick={() =>
                            navigate(
                              "/dashboard/courses/edit/" + bCourse.course._id
                            )
                          }
                        />
                      );
                    })
                  ) : (
                    <div className="py-5 text-gray-600"> No Courses Bought</div>
                  )}
                </div>
              </div>

              <div className="py-4">
                <h1 className="text-xl font-extrabold">Mentee Preferences</h1>
                <div className="my-2 flex flex-col">
                  <div>
                    Push Notification:{" "}
                    <b>
                      {data.setting.pushNotification ? "Enabled" : "Disabled"}
                    </b>
                  </div>

                  <div>
                    Support Notification:{" "}
                    <b>
                      {data.setting.supportNotification
                        ? "Enabled"
                        : "Disabled"}
                    </b>{" "}
                  </div>

                  <div>
                    Email Notification:{" "}
                    <b>
                      {data.setting.emailNotification ? "Enabled" : "Disabled"}
                    </b>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="mx-2">
                <div className="my-2">
                  <h1 className="text-xl font-extrabold">Course Schedule</h1>
                  {data.schedule.courses.length == 0 && (
                    <div className="py-5 text-gray-600"> No Sessions</div>
                  )}
                  {data.schedule.courses.map((event, index) => {
                    const isPast = moment(event.startTime).isBefore();

                    return (
                      <div
                        className={
                          "p-2 text-sm m-2 rounded-sm flex items-center max-w-lg " +
                          (isPast ? " bg-green-200 " : " bg-secondary ")
                        }
                      >
                        <div>
                          {isPast ? (
                            <TbCircleCheck size={20} />
                          ) : (
                            <FaRegCalendarAlt size={14} />
                          )}
                        </div>
                        <div className="font-bold px-2">{event.topicName}</div>
                        <div>{event.friendlyTime}</div>
                        <div className="ml-auto">
                          {moment(event.startTime).format("dddd, MMMM Do YYYY")}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="my-4">
                  <h1 className="text-xl font-extrabold">
                    Counselling Schedule
                  </h1>
                  {data.schedule.counselling.length == 0 && (
                    <div className="py-5 text-gray-600"> No Sessions</div>
                  )}
                  {data.schedule.counselling.map((event, index) => {
                    const isPast = moment(event.startTime).isBefore();
                    return (
                      <div
                        className={
                          "p-2 text-sm m-2 rounded-sm flex items-center max-w-lg " +
                          (isPast ? " bg-green-200 " : " bg-secondary ")
                        }
                      >
                        <div>
                          {isPast ? (
                            <TbCircleCheck size={20} />
                          ) : (
                            <FaRegCalendarAlt size={14} />
                          )}
                        </div>
                        <div className="font-bold px-2">
                          {event.mentor.firstname + " " + event.mentor.lastname}
                        </div>
                        <div>{event.friendlyTime}</div>
                        <div className="ml-auto">
                          {moment(event.startTime).format("dddd, MMMM Do YYYY")}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="my-4">
                  <h1 className="text-xl font-extrabold">
                    Reschedule Requests
                  </h1>
                  {rs.length == 0 && (
                    <div className="py-5 text-gray-600">
                      {" "}
                      No Reschedule Requests
                    </div>
                  )}
                  {rs.map((req, index) => {
                    return (
                      <div
                        className={
                          "p-2 text-sm m-2 rounded-sm flex flex-col max-w-lg bg-secondary "
                        }
                      >
                        <div className="flex  items-center">
                          <div>
                            <FaRegCalendarAlt size={14} />
                          </div>
                          <div className="font-bold px-2">
                            {req.session.topic.name}
                          </div>
                          <div>{"SESSION " + req.session.sessionNumber}</div>
                          <div className="ml-auto">
                            {"BATCH " + req.courseClass.batchNumber}{" "}
                          </div>
                        </div>
                        <div>
                          {moment(req.time).format(Constants.DATE_TIME_FORMAT)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <BillingDialog
          open={billingDialog}
          data={data.billing}
          onClose={() => {
            setBillingDialog(false);
          }}
        />
      </div>
    )
  );
}

export default SingleMentee;
